import { isApiErrorDto } from "../../../common/errors/isApiErrorDto";
import { isFetchBaseQueryError } from "../../../common/errors/isFetchBaseQueryError";

const FOR_ANOTHER_AWARD = "zz_SourcingEventApiErrorCode_WinnerDocumentationForAnotherAward";
const ALREADY_RECORDED = "zz_SourcingEventApiErrorCode_WinnerDocumentationAlreadyRecorded";

const hasErrorCode = (e: unknown, code: string): boolean =>
  e != null && isFetchBaseQueryError(e) && isApiErrorDto(e.data) && e.data.errorCode === code;

export const isCheckForAnotherAward = (e: unknown): boolean => hasErrorCode(e, FOR_ANOTHER_AWARD);

export const isCheckAlreadyRecorded = (e: unknown): boolean => hasErrorCode(e, ALREADY_RECORDED);
